import { cn } from '@gto/ui/cn'

import type { ModalMediaAlign, ModalMediaWidth } from './modal-block-types'
import { modalMediaLayoutClass } from './modal-media-layout'

type ModalImageBlockProps = {
  url: string
  centerOnMobile?: boolean
  align?: ModalMediaAlign
  width?: ModalMediaWidth
}

export const ModalImageBlock = ({ url, align, width, centerOnMobile }: ModalImageBlockProps) => (
  <img
    alt=""
    src={url}
    className={cn(
      'rounded-sm',
      modalMediaLayoutClass(width, align),
      centerOnMobile === true && 'sm:mx-auto',
    )}
  />
)
